import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";




const getStakeholders = async () => {
    const UserString = localStorage.getItem("user");
    const User = JSON.parse(UserString);
    const id = User.id;
    const response = await axios.get(`${base_url}StackHolder/getStackHolderByPPPIdForAdmin/${id}/${0}`);

    return response.data;

};


const getStakeholder = async () => {
    const UserString = localStorage.getItem("user");
    const User = JSON.parse(UserString);
    const id = User.id;
    const response = await axios.get(`${base_url}StackHolder/getStackHolderByPPPIdForAdmin/${id}/${1}`, config);

    return response.data;
};

const updateStakeholder = async (id,isVerified) => {

    const response = await axios.patch(
        `${base_url}StackHolder/verifyStackHolderByPPPIdForAdmin/${id}`,{
            isVerified,
          },config
    );

    return response.data;
};

const createStakeholders = async (formData) => {
    const UserString = localStorage.getItem("user");
    const User = JSON.parse(UserString);
    const id = User.id;
    const response = await axios.post(`${base_url}StackHolder/${id}/addStakeholder`, formData);

    return response.data;
};

const deleteStakeholder = async (idd) => {
    const UserString = localStorage.getItem("user");
    const User = JSON.parse(UserString);
    const id = User.id;
    const response = await axios.delete(`${base_url}StackHolder/deleteStackHolderByPPPIdForAdmin/${idd}`, config);

    return response.data;
};
const StakeholderService = {
    getStakeholders,
    createStakeholders,
    getStakeholder,
    updateStakeholder,
    deleteStakeholder,
};

export default StakeholderService;
